<template>
  <div :class="{ active: show }" class="toast-overlay">
    <div class="toast-container">
      <!-- 关闭按钮 -->
      <div class="toast-close" @click="close">
        <CloseCircleOutlined />
      </div>

      <!-- 成功图标（可选） -->
      <div v-if="icon" class="toast-icon">
        <svg viewBox="0 0 24 24" width="56" height="56" fill="none">
          <circle cx="12" cy="12" r="10" stroke="#52c41a" stroke-width="2" />
          <path d="M8 12L11 15L16 9" stroke="#52c41a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      <!-- 标题 -->
      <div class="toast-title">{{ title }}</div>

      <!-- 描述 -->
      <div v-if="desc && desc.length > 0" class="toast-desc">{{ desc }}</div>

      <!-- 按钮区 -->
      <div class="toast-actions">
        <button v-if="cancelShow" class="toast-btn cancel" @click="cancel">
          {{ cancelText || 'Cancel' }}
        </button>
        <button class="toast-btn confirm" @click="ok">
          {{ okText || 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'

export default {
  name: 'ToastVue',
  components: {
    CloseCircleOutlined
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: ''
    },
    ok: {
      type: Function,
      default: () => {}
    },
    cancelText: {
      type: String,
      default: ''
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    cancelShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    }
  }
}
</script>

<style scoped>
/* ============================================================
   Toast 弹框 - 暗色主题
   ============================================================ */

.toast-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.toast-overlay.active {
  visibility: visible;
  opacity: 1;
}

/* ===== 弹窗卡片 ===== */
.toast-container {
  position: relative;
  width: 400px;
  max-width: 92vw;
  padding: 32px 28px 28px;
  background: #141a20;
  border-radius: 16px;
  border: 1px solid #1e262e;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6);
  transform: scale(0.92) translateY(20px);
  transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.toast-overlay.active .toast-container {
  transform: scale(1) translateY(0);
}

/* ===== 关闭按钮 ===== */
.toast-close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
  color: #5a6672;
  cursor: pointer;
  transition: all 0.25s;
  font-size: 18px;
}

.toast-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #e8edf2;
  transform: rotate(90deg);
}

/* ===== 成功图标 ===== */
.toast-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

/* ===== 标题 ===== */
.toast-title {
  color: #e8edf2;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  line-height: 1.4;
}

/* ===== 描述 ===== */
.toast-desc {
  color: #8a949f;
  font-size: 15px;
  text-align: center;
  margin-top: 8px;
  line-height: 1.6;
  padding: 0 8px;
}

/* ===== 按钮区 ===== */
.toast-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.toast-btn {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

/* 取消按钮 */
.toast-btn.cancel {
  background: rgba(255, 255, 255, 0.06);
  color: #8a949f;
}

.toast-btn.cancel:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #e8edf2;
}

/* 确认按钮 */
.toast-btn.confirm {
  background: linear-gradient(135deg, #e50914, #b20710);
  color: #fff;
  box-shadow: 0 4px 20px rgba(229, 9, 20, 0.25);
}

.toast-btn.confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(229, 9, 20, 0.35);
}

.toast-btn.confirm:active {
  transform: scale(0.97);
}

/* ===== 只有一个按钮时居中 ===== */
.toast-actions:has(.cancel:only-child) .cancel,
.toast-actions:has(.confirm:only-child) .confirm {
  flex: 0 1 auto;
  padding: 12px 40px;
}

/* ===== 响应式 ===== */
@media (max-width: 480px) {
  .toast-container {
    padding: 24px 18px 20px;
  }

  .toast-title {
    font-size: 17px;
  }

  .toast-desc {
    font-size: 14px;
  }

  .toast-btn {
    padding: 10px 16px;
    font-size: 14px;
  }

  .toast-actions {
    gap: 10px;
  }

  .toast-close {
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
    font-size: 16px;
  }
}
</style>
